var isKind = require('./isKind');
    /**
     */
    var isArray = Array.isArray || function (val) {
        return isKind(val, 'Array');
    };
    module.exports = isArray;




/*****************
 ** WEBPACK FOOTER
 ** ./~/mout/lang/isArray.js
 ** module id = 38
 ** module chunks = 0
 **/